module.exports = __webpack_public_path__ + "static/nxrt-esports3-c1e35f05628420c7b6a380fb2f3ea729.jpg";